export type CampaignLink = {
  link: string;
  nome: string;
};

export function normalizeCampaignLinks(links: unknown): CampaignLink[] {
  const parsedLinks = (() => {
    if (Array.isArray(links)) return links;

    if (typeof links === "string" && links.trim()) {
      try {
        const parsed = JSON.parse(links);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }

    return [];
  })();

  return parsedLinks
    .filter((item) => item && typeof item === "object")
    .map((item: any) => ({
      link: String(item.link ?? "").trim(),
      nome: String(item.nome ?? "").trim(),
    }))
    .filter((item) => item.link || item.nome);
}
